<script setup lang="ts">
import AuthCard from '@/components/AuthCard.vue'
import { Head } from '@inertiajs/vue3'
import { onBeforeUnmount, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

let refreshInterval: number | undefined

onMounted(() => {
  refreshInterval = window.setInterval(() => {
    window.location.reload()
  }, 60_000)
})

onBeforeUnmount(() => {
  window.clearInterval(refreshInterval)
})
</script>

<template>
  <Head :title="t('title')" />

  <AuthCard>
    <template #title>
      <div class="flex items-center gap-3">
        <span
          class="bg-action-50 text-action-800/60 flex size-16 shrink-0 items-center justify-center rounded-full"
          aria-hidden="true">
          <i class="pi pi-wrench !text-3xl" />
        </span>
        <span>{{ t('title') }}</span>
      </div>
    </template>

    <template #subtitle>
      {{ t('subtitle') }}
    </template>

    <template #content>
      <div class="text-surface-700 grid gap-3">
        <div class="flex gap-3">
          <span
            class="bg-action-50 text-action/70 flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold"
            aria-hidden="true">
            1
          </span>
          <p class="m-0 leading-6">{{ t('details.updates') }}</p>
        </div>

        <div class="flex gap-3">
          <span
            class="bg-action-50 text-action/70 flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold"
            aria-hidden="true">
            2
          </span>
          <p class="m-0 leading-6">{{ t('details.reload') }}</p>
        </div>

        <div class="flex w-full justify-center pt-12">
          <!-- spinner -->
          <ProgressSpinner
            style="width: 50px; height: 50px"
            stroke-width="4"
            fill="transparent"
            animation-duration="5s"
            aria-label="Maintenance in progress" />
        </div>
      </div>
    </template>
  </AuthCard>
</template>

<i18n>
{
  "de": {
    "title": "Wartungsarbeiten",
    "subtitle": "FinEstHub ist aktuell nicht erreichbar. Wir nutzen dieses Wartungsfenster, um die Plattform stabil und aktuell zu halten.",
    "details": {
      "updates": "Wir aktualisieren gerade die Plattform und prüfen sie im Anschluss sorgfältig.",
      "reload": "In wenigen Minuten ist die Plattform wieder erreichbar."
    }
  },
  "en": {
    "title": "Maintenance work",
    "subtitle": "FinEstHub is currently unavailable. We are using this maintenance window to keep the platform stable and up to date.",
    "details": {
      "updates": "We are applying updates and carefully checking the platform afterwards.",
      "reload": "We will be back online shortly."
    }
  }
}
</i18n>
